import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const RESOURCE_ICONS = [
  "ri-grid-line",
  "ri-star-line",
  "ri-truck-line",
  "ri-archive-line",
  "ri-coupon-3-line",
  "ri-shield-check-line",
];

const HUB_ICONS = [
  "ri-list-check-2",
  "ri-search-line",
  "ri-user-search-line",
  "ri-truck-line",
  "ri-archive-line",
  "ri-star-line",
  "ri-coupon-3-line",
  "ri-shield-check-line",
];

export default function ResourcesSection() {
  const { t } = useTranslation();
  const resources = t("resources.items", { returnObjects: true }) as { title: string; desc: string }[];
  const hubCards = t("hub.cards", { returnObjects: true }) as string[];

  return (
    <section id="resources" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("resources.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
            {t("resources.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {resources.map((item, i) => (
            <a
              key={item.title}
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${RESOURCE_ICONS[i] ?? "ri-grid-line"} text-lg`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700">
                {t("cta.visitMain")}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </span>
            </a>
          ))}
        </div>

        <div className="mt-16 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
          <h3 className="text-center font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {t("hub.title")}
          </h3>
          <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-foreground-700">{t("hub.copy")}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {hubCards.map((card, i) => (
              <span
                key={card}
                className="flex items-center gap-2 whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-50 px-4 py-2 text-sm font-medium text-secondary-900"
              >
                <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                  <i className={`${HUB_ICONS[i] ?? "ri-grid-line"} text-sm`}></i>
                </span>
                {card}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}